import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { selectIsLoggedIn, selectRole } from "../redux/auth/authSelectors";
export const RestrictedRoute = ({
  component: Component,
  redirectTo = "/",
  redirectToThirdRole = "/",
}) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const role = useSelector(selectRole);

  return isLoggedIn ? (
    <Navigate to={role !== 3 ? redirectTo : redirectToThirdRole} />
  ) : (
    <Component />
  );
};
